<template>
<div class="warp">
    <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" src="http://47.99.177.252:5505/3D/public/level/RVT.html" allowfullscreen="true"></iframe> 
    <div class="posi">
        <el-tree
            :data="tree"
            show-checkbox
            node-key="nodeID"
            @check-change='select'
            @node-click="handleNodeClick"
            :props="defaultProps">
        </el-tree>
    </div>
</div>
    
</template>

<script>
import * as Cesium from "cesium/Cesium";
import * as widgets from "cesium/Widgets/widgets.css";

export default {
    components:{
    },
    data(){
        return {
            tree:[],
            defaultProps: {
                children: 'children',
                label: 'name'
            }
        }
    },
    mounted(){
        window.addEventListener("message", this.handleMessage);
        this.iframeWin = this.$refs.iframeDom.contentWindow;
    },
    methods:{
        handleMessage(event) {
            let _this = this
            const data = event.data;
            // console.log(data)
            switch (data.cmd) {
                case "tree":
                    _this.tree = [data.params.data]
                    console.log(_this.tree);
                    break;
            }
        },
        handleNodeClick(data) {
            console.log(data);
            this.iframeWin.postMessage({
                cmd: 'nodeID',
                data:data.nodeID
            }, "*");
        },
        select(node, flag){
            console.log(node, flag);
            if(node.name != 'RootNode'){
                this.iframeWin.postMessage({
                    cmd: 'modelName',
                    data:node.name,
                    flag
                }, "*");
            }
            
        }
    }
}
</script>

<style scoped lang="less">
.warp{
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .posi{
        position: fixed;
        left: 1vw;
        top: 5vh;
        width: 22vw;
        max-height: 50vh;
        overflow-y: scroll;
        // overflow-x: hidden;

    }
}
</style>